module.exports = __webpack_public_path__ + "static/media/feedback.0d1cdaed.svg";